import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Img from '../../../../../images/pc-optimum-circles-bg.svg';

export const OptimumCircles = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  margin: 0 auto;
  background-color: ${themeGet('colors.pc-red', '#E1251B')};
  background-size: 100%;
  background-position: top right;
  background-repeat: no-repeat;
  background-image: url(${Img});
`;
